
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 13.8,
    height: 16.5,
    viewBox: '0 0 13.8 16.5',
    data: '<path pid="0" d="M1.4 8.9l4.3 4.3.1.1c.7.6 1.8.6 2.4-.1l4.4-4.4c.3-.3.3-.7 0-1-.1-.1-.3-.2-.5-.2s-.4.1-.5.2l-3.8 3.8V.8C7.8.4 7.5 0 7 0s-.7.3-.7.8v10.8L2.5 7.8c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1zm-.5 6.2h12.2c.4 0 .7.3.7.7 0 .4-.3.7-.8.7H.8c-.4 0-.8-.3-.8-.7 0-.4.5-.7.9-.7z"/>'
  }
})
